import type { IClientContextAction } from '@client/lib/ClientContext';
import { setCookie } from '@client/lib/Cookie';
import { CookieKey } from '@const/index';
import React from 'react';

export const toggleTheme = (isDark: boolean, dispatchContext: React.Dispatch<IClientContextAction>) => {
    setCookie(CookieKey.THEME, isDark ? 'd' : 'l', 180);

    dispatchContext({
        event: 'set_theme',
        theme: isDark ? 'dark' : 'light',
    });
};
